import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import Aboutme from '../Pages/HomePage/Aboutme';
import ContactMe from '../Pages/HomePage/ContactMe';
import Main from '../Layouts/Main';
import Homepage from '../Pages/HomePage/Homepage';
import Portfolio from '../Pages/HomePage/Portfolio';
import Achievement from '../Pages/HomePage/Achievement';
import Skill from '../Pages/HomePage/Skill';


export const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Homepage></Homepage>,
            },
            {
                path: '/aboutme',
                element: <Aboutme></Aboutme>
            },
            {
                path: '/contact',
                element: <ContactMe></ContactMe>
            },
            {
                path: '/portfolio',
                element: <Portfolio></Portfolio>,
            },
            {
                path: '/achievement',
                element: <Achievement></Achievement>
            },
            {
                path: '/skill',
                element: <Skill></Skill>
            },

        ]
    }
])